import React, { useEffect, useState } from 'react'
import { Button, Modal, Table, Typography } from 'antd'
import { ApiCalls } from '../../../shared'
const { Text } = Typography

const CsvModal = ({visible, callback, csvData, onClose}) => {

    const [data, setData]= useState([])
    const [loading, setLoading]= useState(false)

    const columns = [
        {
            title: <Text>serial #</Text>,
            dataIndex: 'serialNo',
            key: 'serialNo',
        },
        {
            title: <Text>Mac Address</Text>,
            dataIndex: "macAddress",
            key: "macAddress",
        }
    ]
    useEffect(()=>{
    if(csvData?.length){
        console.log("Ham CSV verisi:", csvData);
        let temp = csvData[0]?.length === 1 ? convertArray(csvData) : csvData;
        console.log("Convert edilmiş veri:", temp);
        let columns = temp[0];
        // Sütun isimlerindeki boşlukları temizle ve normalize et
        columns = columns.map(col => {
            if (typeof col === 'string') {
                const trimmed = col.trim();
                // Sütun isimlerini normalize et (case-insensitive)
                if (trimmed.toLowerCase() === 'serialno' || trimmed.toLowerCase() === 'serial_no' || trimmed.toLowerCase() === 'serial no') {
                    return 'serialNo';
                }
                // macAddress için farklı yazım şekillerini destekle (macAdress yanlış yazılmış versiyonu da dahil)
                const macLower = trimmed.toLowerCase();
                if (macLower === 'macaddress' || macLower === 'mac_address' || macLower === 'mac address' || 
                    macLower === 'macadress' || macLower === 'mac_adress' || macLower === 'mac adress') {
                    return 'macAddress';
                }
                return trimmed;
            }
            return col;
        });
        console.log("Normalize edilmiş sütunlar:", columns);
        temp = [...temp?.filter((_, index)=> index>0)];
        for(let i=0; i < temp?.length; i++){
            let obj = {};
            for(let j=0; j<temp[i]?.length; j++) {
                // Değerlerdeki boşlukları temizle
                const value = (typeof temp[i][j] === 'string' ? temp[i][j].trim() : temp[i][j]);
                obj = {...obj, [columns[j]]: value};
            }
            temp[i] = obj;
        }
        console.log("Obje haline getirilmiş veri:", temp);
        // macAdress (yanlış yazılmış) varsa macAddress'e dönüştür
        temp = temp.map(item => {
            if (item.macAdress && !item.macAddress) {
                item.macAddress = item.macAdress;
                delete item.macAdress;
            }
            return item;
        });
        // Boş olmayan serialNo ve macAddress olanları filtrele
        temp = temp.filter(item => {
            const hasSerialNo = item.serialNo && item.serialNo.toString().trim() !== '';
            const hasMacAddress = (item.macAddress && item.macAddress.toString().trim() !== '') || 
                                 (item.macAdress && item.macAdress.toString().trim() !== '');
            return hasSerialNo && hasMacAddress;
        });
        console.log("Filtrelenmiş veri:", temp);
        setData(temp);
    } else {
        setData([]);
    }
}, [csvData]);

    const convertArray =(inputArray)=> {
        return inputArray
            .filter(row => row.length > 0 && row[0])
            .map(row => row[0].split(";").map(cell => (typeof cell === 'string' ? cell.trim() : cell)))
    }
    
    const saveUpdateMultipleBpxes= async ()=>{
        setLoading(true)
        // API'ye gönderilmeden önce tüm verilerdeki boşlukları temizle
        const cleanedData = data.map(device => {
            // macAdress (yanlış yazılmış) varsa macAddress'e dönüştür
            const macAddr = device.macAddress || device.macAdress;
            const cleanedDevice = {
                serialNo: (device.serialNo && typeof device.serialNo === 'string' ? device.serialNo.trim() : device.serialNo) || '',
                macAddress: (macAddr && typeof macAddr === 'string' ? macAddr.trim() : macAddr) || ''
            };
            return cleanedDevice;
        }).filter(device => device.serialNo && device.macAddress); // Son bir kontrol daha
        
        console.log("Gönderilecek payload:", { devices: cleanedData });
        console.log("Payload JSON:", JSON.stringify({ devices: cleanedData }, null, 2));

        if(cleanedData.length === 0) {
            console.error("Gönderilecek veri yok! Lütfen CSV dosyasını kontrol edin.");
            setLoading(false);
            return;
        }

        const result= await ApiCalls?.boxManagementGo?.addMultipleBoxes({devices: cleanedData})
        if(result){
            onClose()
            callback()
        }
        setLoading(false)
    }
  return (
    <Modal
        title="Add mutiple android boxes"
        centered
        open={visible}
        onCancel={onClose}
        footer={[
            <Button loading={loading} type='primary' onClick={saveUpdateMultipleBpxes}>Add Boxes</Button>
        ]}
        width={950}
      >
        <Table
            size='large'
            columns={columns} 
            dataSource={data}     
            pagination={{ 
                hideOnSinglePage: true, 
                total: csvData?.length,
                pageSize: 10,
                defaultPageSize: 10,
                size: "default",
                pageSizeOptions:['20', '50', '100'],
                showTotal: total => <Button>Total: {total}</Button>
            }}
            // scroll={{y: 400}}
        />

        
    </Modal>
  )
}

export {CsvModal}